export const langImports: Record<string, () => Promise<any>> = {
  en_US: () => import("../lang/TeamsTcAppMessages_en_US.json"),
  cs_CZ: () => import("../lang/TeamsTcAppMessages_cs_CZ.json"),
  de_DE: () => import("../lang/TeamsTcAppMessages_de_DE.json"),
  es_ES: () => import("../lang/TeamsTcAppMessages_es_ES.json"),
  fr_FR: () => import("../lang/TeamsTcAppMessages_fr_FR.json"),
  it_IT: () => import("../lang/TeamsTcAppMessages_it_IT.json"),
  ja_JP: () => import("../lang/TeamsTcAppMessages_ja_JP.json"),
  ko_KR: () => import("../lang/TeamsTcAppMessages_ko_KR.json"),
  pl_PL: () => import("../lang/TeamsTcAppMessages_pl_PL.json"),
  pt_BR: () => import("../lang/TeamsTcAppMessages_pt_BR.json"),
  ru_RU: () => import("../lang/TeamsTcAppMessages_ru_RU.json"),
  zh_CN: () => import("../lang/TeamsTcAppMessages_zh_CN.json"),
  zh_TW: () => import("../lang/TeamsTcAppMessages_zh_TW.json"),
};
